module.exports = __webpack_public_path__ + "./img/Inspector-icon.svg";